import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

export const BrandLogo = ({ size = "md", className = "" }: { size?: "sm" | "md" | "lg"; className?: string }) => {
  const dims = { sm: "w-8 h-8", md: "w-10 h-10", lg: "w-20 h-20" };
  return (
    <div className={`${dims[size]} relative flex items-center justify-center shrink-0 ${className}`}>
      <img 
        src="/Alt-X-Logo-v2.png" 
        alt="Alt-X Logo" 
        className="w-full h-full object-contain"
      />
    </div>
  );
};

export const Navbar = ({ onSignIn, onSignUp, onRunClick, isAuthenticated, onSignOut, onDashboard }: any) => {
  const navigate = useNavigate();
  const [os, setOs] = React.useState<'windows' | 'mac' | 'mobile' | null>(null);

  React.useEffect(() => {
    const userAgent = window.navigator.userAgent;
    // @ts-ignore
    const platform = window.navigator.platform;
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
    const mobilePlatforms = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

    if (mobilePlatforms.test(userAgent)) {
      setOs('mobile');
    } else if (macosPlatforms.indexOf(platform) !== -1 || /Mac/.test(userAgent)) {
      setOs('mac');
    } else if (windowsPlatforms.indexOf(platform) !== -1 || /Win/.test(userAgent)) {
      setOs('windows');
    }
  }, []);

  const getDownloadText = () => {
    if (os === 'mobile') return 'Download for Excel';
    if (os === 'mac') return 'Download for Mac';
    if (os === 'windows') return 'Download for Windows';
    return 'Download Add-in';
  };

  return (
    <nav className="fixed top-9 left-0 right-0 h-16 glass border-b border-brand-border z-50 transition-all bg-white/80 backdrop-blur-md">
      <div className="w-full px-6 md:px-8 h-full flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/excel')}>
          <div className="bg-white border border-brand-border p-1 rounded-md shadow-sm">
            <BrandLogo size="sm" />
          </div>
          <span className="font-bold text-lg tracking-tight text-zinc-900">Alt-X</span>
        </div>
        
        <div className="hidden md:flex items-center gap-8">
          <a href="/excel#pricing" className="text-sm font-medium text-zinc-500 hover:text-zinc-900 transition-colors" onClick={(e) => {
            if (window.location.pathname === '/excel') {
              e.preventDefault();
              document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
            }
          }}>Pricing</a>
          <a href="/excel#how-it-works" className="text-sm font-medium text-zinc-500 hover:text-zinc-900 transition-colors" onClick={(e) => {
            if (window.location.pathname === '/excel') {
              e.preventDefault();
              document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
            }
          }}>Workflow</a>
          <a href="/enterprise" className="text-sm font-medium text-zinc-500 hover:text-zinc-900 transition-colors">Enterprise</a>
          <a href="/support" className="text-sm font-medium text-zinc-500 hover:text-zinc-900 transition-colors">Support</a>
          <Button variant="default" className="py-2 px-5 h-9 text-xs bg-zinc-900 hover:bg-zinc-800 text-white" onClick={() => {
             navigate('/download');
          }}>{getDownloadText()}</Button>
          
          {isAuthenticated && (
             <>
              <div className="h-6 w-px bg-zinc-200"></div>
              <Button variant="ghost" className="py-2 px-3 h-9 text-xs text-zinc-500 hover:text-zinc-900" onClick={onDashboard}>Dashboard</Button>
              <Button variant="outline" className="py-2 px-3 h-9 text-xs bg-transparent border-zinc-200 hover:bg-zinc-50" onClick={onSignOut}>Sign Out</Button>
             </>
          )}
        </div>
      </div>
    </nav>
  );
};

export const Banner = () => (
  <div className="fixed top-0 left-0 right-0 h-9 bg-black z-[60] flex items-center justify-center gap-3 text-white text-[10px] font-bold uppercase tracking-[0.2em] border-b border-white/10">
    <span className="text-zinc-400">Backed by</span>
    <div className="flex items-center gap-2">
      <img src="/Y_Combinator_logo.svg.png" alt="Y Combinator" className="h-3.5 w-auto" />
      <span>Combinator</span>
    </div>
  </div>
);

export const Footer = () => (
  <footer className="py-16 bg-white border-t border-brand-border">
    <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-12">
      <div className="flex items-center gap-3">
        <div className="bg-white border border-brand-border p-1 rounded-md">
          <BrandLogo size="sm" />
        </div>
        <span className="font-bold text-lg tracking-tight text-[#111]">Alt-X Financial</span>
      </div>
      <div className="text-zinc-400 text-[11px] font-bold uppercase tracking-[0.5em] select-none">
        © {new Date().getFullYear()} Alt-X Financial
      </div>
      <div className="flex gap-10 text-[11px] font-bold text-zinc-500 uppercase tracking-widest">
        <a href="/support" className="hover:text-zinc-900 transition-colors">Support</a>
        <a href="/privacy-policy" className="hover:text-zinc-900 transition-colors">Privacy</a>
        <a href="/terms-of-service" className="hover:text-zinc-900 transition-colors">Terms</a>
        <a href="/eula" className="hover:text-zinc-900 transition-colors">EULA</a>
      </div>
    </div>
  </footer>
);

